const route = {
	path: ':codeProject/web-services',
	name: 'page-web-services',
	meta: {
		title: 'Web Services',
	},
	props: true,
	component: () => import('@/pages/web-services/page-web-services'),
	children: [
		{
			path: 'new',
			name: 'page-new-web-services',
			meta: {
				title: 'Agregar Web Services',
			},
			props: true,
			component: () => import('@/pages/web-services/page-new-web-services'),
		},
		{
			path: ':id/edit',
			name: 'page-edit-web-services',
			meta: {
				title: 'Editar Web Services',
			},
			props: true,
			component: () => import('@/pages/web-services/page-new-web-services'),
		},
	],
};

export default route;



// WEBPACK FOOTER //
// ./src/router/web-services.js